import { useEffect, useState } from "react";
import { X, Sparkles } from "lucide-react";

const KEY = "plumberhq_banner_v1";

export default function PromoBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => { if (!localStorage.getItem(KEY)) setShow(true); }, []);
  if (!show) return null;
  return (
    <div className="rounded-xl bg-blue-50 border border-blue-200 px-3 py-2 flex items-center gap-2 text-sm" data-testid="promo-banner">
      <Sparkles className="w-4 h-4 text-blue-600 flex-shrink-0" />
      <span className="text-blue-900 flex-1">
        <b>14-day free trial</b> active. Plumbing made simple.
      </span>
      <button
        onClick={() => { localStorage.setItem(KEY, "1"); setShow(false); }}
        className="h-7 w-7 rounded-lg hover:bg-blue-100 flex items-center justify-center text-blue-700"
        data-testid="promo-dismiss"
        aria-label="Dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
